import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { SankeyData, SankeyLink, SankeyNode } from "../models/DelayForSankey";

type getDelaysForSankeyProps = {
	startDate: Date;
	endDate: Date;
	delayAreaAssetId?: number | null;
	includeMicroDelays: boolean;
	includeUndeclared: boolean;
	includeRollChange: boolean;
	thresholdPct: number;
	topN: number;
};

export const getDelaysForSankey = async (
	params: getDelaysForSankeyProps,
	signal?: AbortSignal,
): Promise<SankeyData> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Start", value: params.startDate?.toISOString() ?? null },
		{ name: "End", value: params.endDate?.toISOString() ?? null },
		{
			name: "DelayAreaAssetId",
			value: params.delayAreaAssetId || null,
		},
		{
			name: "IncludeMicrodelays",
			value: params.includeMicroDelays,
		},
		{
			name: "IncludeUndeclared",
			value: params.includeUndeclared,
		},
		{
			name: "IncludeRollChange",
			value: params.includeRollChange,
		},
	];

	if (params.thresholdPct) {
		parameters.push({
			name: "ThresholdPct",
			value: params.thresholdPct,
		});
	}

	if (params.topN) {
		parameters.push({
			name: "TopN",
			value: params.topN,
		});
	}

	const resp = await apiService.callV2(
		"[DEL].[GetDelaysForSankey]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const nodes = get(resp, "data.tables[0].rows", []) as SankeyNode[];
		const links = get(resp, "data.tables[1].rows", []) as SankeyLink[];
		return { nodes, links };
	} else {
		throw new Error(resp.message || "Error fetching delays for sankey");
	}
};
